import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const Bankamount = ({ onTotalAmountChange }) => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const [fetchedExpensesData, setFetchedExpensesData] = useState([]);
    const [fetchedData, setFetchedData] = useState([]);
    const [damages, setDamages] = useState([]);
    const [fetchedPaymentData, setFetchedPaymentData] = useState([]);
    const [fetchedAllPaymentData, setFetchedAllPaymentData] = useState([]);
    const navigate = useNavigate();
    const [investments, setInvestments] = useState([]);
    const [balance, setBalance] = useState(0);
    const [expensesPayments, setExpensesPayments] = useState([]);
    

    useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        }
    }, [token]);

    useEffect(() => {
        const fetchProfile = async () => {
          const token = localStorage.getItem("token");
    
          if (!token) {
            navigate("/"); // Redirect if no token
            return;
          }
    
          try {
            const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
              headers: { Authorization: `Bearer ${token}` },
            });
            setUser(response.data);
          } catch (error) {
            if (error.response && error.response.status === 401) {
              localStorage.removeItem("token");
              navigate("/"); // Redirect on 401 error
            }
          }
        };
    
        fetchProfile();
      }, []);

{/**   useEffect(() => {
        if (user.id) {
            fetchData();
            fetchDamages();
            fetchPaymentData();
            fetchPayments();
            fetchExpensesData();
            fetchInvestments();
            fetchExpensesPayments();
        }
    }, [user.id]);

    const fetchInvestments = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-investment');
            if (user.id) {
                const filteredInvestments = response.data.investment.filter(
                    (investment) => investment.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );
                setInvestments(filteredInvestments);
            } else {
                setInvestments([]); // In case user.id is not found
            }
        } catch (error) {
            console.error('Error fetching investment data:', error);
        }
    };

    const fetchData = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-data');
            if (user.id) {
                const orders = response.data.filter(order =>
                    order.usertoken.toLowerCase() === user.id.toString().toLowerCase() &&
                    order.term === 'due on receipt'
                );
                setFetchedData(orders);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchPaymentData = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-data');
            if (user.id) {
                const orders = response.data.filter(order =>
                    order.usertoken.toLowerCase() === user.id.toString().toLowerCase() &&
                    order.term !== 'due on receipt'
                );
                setFetchedPaymentData(orders);
            }
        } catch (error) {
            console.error('Error fetching payment data:', error);
        }
    };

    const fetchPayments = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-payment-data');
            if (user.id) {
                const payments = response.data.filter(payment =>
                    payment.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );
                setFetchedAllPaymentData(payments);
            }
        } catch (error) {
            console.error('Error fetching payments:', error);
        }
    };

    const fetchDamages = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-damage-data');
            if (user.id) {
                const damages = response.data.filter(damage =>
                    damage.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );
                setDamages(damages);
            }
        } catch (error) {
            console.error('Error fetching damages:', error);
        }
    };

    const fetchExpensesData = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-expense-data');
            if (user.id) {
                const expenses = response.data.filter(expense =>
                    expense.usertoken.toLowerCase() === user.id.toString().toLowerCase() &&
                    expense.paymenttype === 'Paid'
                );
    
                setFetchedExpensesData(expenses);
            }
        } catch (error) {
            console.error('Error fetching expenses data:', error);
        }
    };

const fetchExpensesPayments = async () => {
        try {
            const response = await axios.get("https://admin.bizstor.lk/public/api/get-expensespayment");
            if (user.id) {
                const filteredPayments = response.data.filter(
                    (expensespayment) =>
                        expensespayment.usertoken &&
                        expensespayment.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );
    
                setExpensesPayments(filteredPayments);
            }
        } catch (error) {
            console.error("Error fetching expenses payments data:", error);
        } 
    };    
*/}

useEffect(() => {
    if (user.id) {
        fetchAllData();
    }
}, [user.id]);

const fetchAllData = async () => {
    try {
        const [
            investmentsResponse,
            dataResponse,
            paymentDataResponse,
            paymentsResponse,
            damagesResponse,
            expensesDataResponse,
            expensesPaymentsResponse
        ] = await Promise.all([
            axios.get('https://admin.bizstor.lk/public/api/get-investment'),
            axios.get('https://admin.bizstor.lk/public/api/get-data'),
            axios.get('https://admin.bizstor.lk/public/api/get-data'),
            axios.get('https://admin.bizstor.lk/public/api/get-payment-data'),
            axios.get('https://admin.bizstor.lk/public/api/get-damage-data'),
            axios.get('https://admin.bizstor.lk/public/api/get-expense-data'),
            axios.get('https://admin.bizstor.lk/public/api/get-expensespayment')
        ]);

        if (user.id) {
            const userId = user.id.toString().toLowerCase();

            setInvestments(investmentsResponse.data.investment.filter(
                inv => inv.usertoken.toLowerCase() === userId
            ));

            setFetchedData(dataResponse.data.filter(
                order => order.usertoken.toLowerCase() === userId && order.term === 'due on receipt'
            ));

            setFetchedPaymentData(paymentDataResponse.data.filter(
                order => order.usertoken.toLowerCase() === userId && order.term !== 'due on receipt'
            ));

            setFetchedAllPaymentData(paymentsResponse.data.filter(
                payment => payment.usertoken.toLowerCase() === userId
            ));

            setDamages(damagesResponse.data.filter(
                damage => damage.usertoken.toLowerCase() === userId
            ));

            setFetchedExpensesData(expensesDataResponse.data.filter(
                expense => expense.usertoken.toLowerCase() === userId && expense.paymenttype === 'Paid'
            ));

            setExpensesPayments(expensesPaymentsResponse.data.filter(
                expensePayment => expensePayment.usertoken?.toLowerCase() === userId
            ));
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};

    useEffect(() => {

        let total = 0;
        fetchedData.forEach(order => {
            let orderTotal = 0;
            order.items.forEach(item => {
                const itemPrice = Number(item.price);
                const itemTax = item.tax || 0;
                const itemTotal = itemPrice + (itemPrice * (itemTax / 100)); // Adding item-specific tax
                orderTotal += itemTotal;
            });

            const discountPercentage = order.discount || 0;
            const discountAmount = (orderTotal * discountPercentage) / 100; // Calculate discount amount
            orderTotal -= discountAmount; // Apply discount

            total += orderTotal;
        });

        let totalPay = 0;
        fetchedPaymentData.forEach(order => {
            let orderTotal = 0;
            orderTotal += Number(order.payamount) || 0; // Add payamount directly
            totalPay += orderTotal;
        });

        let totalExpenses = 0;
        fetchedExpensesData.forEach(expense => {
            let expensesTotal = 0;
            expense.items.forEach(item => {
                expensesTotal += Number(item.amount);
            });

            totalExpenses += expensesTotal;
               
        });

        let totalAllPayment = 0;
        fetchedAllPaymentData.forEach(payment => {
            let paymentTotal = 0;
            paymentTotal += Number(payment.amount) || 0; // Add payment amount directly
            totalAllPayment += paymentTotal;
        });

        const { damageTotalPrice } = damages.reduce(
            (totals, damage) => {
                damage.items.forEach(item => {
                    if (damage.type === 'money back') {
                        totals.damageTotalPrice += Number(item.price);
                    }
                });
                return totals;
            },
            { damageTotalPrice: 0 }
        );

        const totalFromBank = investments
            .filter((investment) => investment.from === 'bank')
            .reduce((sum, investment) => sum + (Number(investment.amount) || 0), 0);

        const totalToBank = investments
            .filter((investment) => investment.to === 'bank')
            .reduce((sum, investment) => sum + (Number(investment.amount) || 0), 0);

        const calculatedBalance = totalToBank - totalFromBank;
        setBalance(calculatedBalance);

        const totalExpensesPayments = expensesPayments.reduce(
            (sum, payment) => sum + (Number(payment.amount) || 0), 
            0
        );

        const finalTotal = (total - damageTotalPrice + totalPay + totalAllPayment - totalExpenses + calculatedBalance - totalExpensesPayments).toFixed(2);

        if (onTotalAmountChange) {
            onTotalAmountChange(parseFloat(finalTotal)); // Send finalTotal to parent component
        }
    }, [fetchedData, damages, onTotalAmountChange, fetchedPaymentData, fetchedAllPaymentData,fetchedExpensesData]);

    

    return null; // No UI for this component
};

export default Bankamount;
